// Thin lazy wrapper around posthog-js so feature code can fire-and-forget
// product events without pulling 50KB+ into the initial bundle and without
// caring whether posthog is initialised, blocked, or absent in tests.
//
// Usage:
//   import { track } from '@/lib/telemetry';
//   track('onboarding_started', { locale: 'en' });
//
// Failure modes (missing key, ad-blocker, SSR, posthog not yet loaded) all
// degrade silently — telemetry is never load-bearing.

type Props = Record<string, unknown>;

const getPosthog = () =>
  import('posthog-js')
    .then(m => m.default)
    .catch(() => null);

export function track(event: string, props?: Props): void {
  // Skip in test/SSR — posthog init is gated on a real window + env key.
  if (typeof window === 'undefined') return;
  void getPosthog().then(ph => {
    if (!ph) return;
    try {
      ph.capture(event, props);
    } catch {
      // Never let analytics break a user-facing flow.
    }
  });
}
